import React from 'react';
import Search from './components/Search';
import CreateBtn from './components/CreateBtn';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import { CustomerSelect } from './components/CustomerSelect';
import ChangePositionBtn from './components/ChangePositionBtn';
import { RestaurantSelect } from './components/RestaurantSelect';
import ModifierGroupSelect from './components/ModifierGroupSelect';
import PriceFilter from './components/PriceFilter/PriceFilter';
import ComboItemsSwitch from './components/ComboItemsSwitch';
import ModifiersInStopCheckBox from './components/ModifiersInStopCheckBox';
import RestrictedModifiersCheckBox from './components/RestrictedModifiersCheckBox';
import WithURLFilters from './components/WithURLFilters';
import style from './ModifiersControlPanel.module.scss';

const ModifiersControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
				<ChangePositionBtn />
			</div>
			<div className={style.selectWrapper}>
				<CustomerSelect />
				<RestaurantSelect />
				<ModifierGroupSelect />
			</div>
			<div className={style.secondRowWithControls}>
				<ModifiersInStopCheckBox />
				<RestrictedModifiersCheckBox />
				<ComboItemsSwitch />
				<PriceFilter />
			</div>
			<div className={style.verticalAlignBlock}>
				<ResetBtn />
				<SortBy />
				<CountOfItem />
			</div>
		</WithURLFilters>
	);
};

export default ModifiersControlPanel;
